import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-section-two',
  templateUrl: './blog-section-two.component.html',
  styleUrls: ['./blog-section-two.component.scss']
})
export class BlogSectionTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
